import React from "react"
import { getImage } from "gatsby-plugin-image"
import { BgImage } from "gbimage-bridge"
import styled from "styled-components"
import { Row, Col } from "reactstrap"
import { media } from "utils/Media"
import ContainerMax from "components/shared/ContainerMax"
import ContentMax from "components/shared/ContentMax"
import WPLink from "components/shared/WPLink"

const ContainerMaxStyled = styled(ContainerMax)`
	position: relative;
	z-index: 1;

	&:before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		/* background: linear-gradient(358.57deg, #000000 9.6%, rgba(0, 0, 0, 0) 90%); */
		background: linear-gradient(90deg, #333F48 0%, rgba(51, 63, 72, 0) 73.7%);;
		/* opacity: 0.6; */
		z-index: 1;
	}
`

const ContentMaxStyled = styled(ContentMax)`
	color: white;
	min-height: 570px;
	display: flex;
	align-items: flex-end;
	justify-content: center;
	text-align: center;
	padding-right: ${props => props.theme.bootstrapGutterWidth};
	padding-left: ${props => props.theme.bootstrapGutterWidth};
	padding-top: 1rem;
	padding-bottom: 1rem;
	position: relative;
	z-index: 2;
	padding-bottom: 2rem;
	@media ${media.md} {
		align-items: center;
		padding-top: 2rem;
		padding-bottom: 2rem;
		padding-right: 2rem;
		padding-left: 2rem;
	}
	@media ${media.md} {
		text-align: left;
		h3 {
			font-size: ${props => props.theme.font.size.xxl};
		}
	}

	@media ${media.xxl} {
		min-height: 760px;
	}

	h3 {
		color: ${props => props.theme.colors.secondary};
		font-family: ${props => props.theme.font.family.heading};
		////font-style: italic;
		text-transform: uppercase;

	}
	> div {

	h3 {
		font-size: ${props => props.theme.font.size.xxl};
		@media ${media.lg} {
			font-size: 3.5rem;
		}
	}
	p {
		font-family: ${props => props.theme.font.family.heading};
		text-transform: uppercase;
		margin: 0 auto;
		max-width: 400px;
		text-align: center;
		@media ${media.md} {
			text-align: left;
			margin-left: 0;
		}

	}
	}
`

const CtaWithBackgroundImage = (props) => {
	const sources = [
		getImage(props.block.imageMobile.localFile),
		{
			...getImage(props.block.imageDesktop.localFile),
			media: `(min-width: 768px)`,
		},
	];

	return(
		<ContainerMax maxWidth="1920" noPadding>
			<BgImage image={sources}>
				<ContainerMaxStyled maxWidth="1920" noPadding>
					<ContentMaxStyled>
						<Row className="w-100">
							<Col md={8}>
								{props.block.title &&
									<h3>
										{props.block.title}
									</h3>
								}
								{props.block.text && 
									<div dangerouslySetInnerHTML={{ __html: props.block.text }} />
								}
								{props.block.link &&
									<div className="pt-3">
										<WPLink url={props.block.link.url} color="primary" target={props.block.link.target} button>
											{props.block.link.title}
										</WPLink>
									</div>
								}
							</Col>
						</Row>
					</ContentMaxStyled>
				</ContainerMaxStyled>
			</BgImage>
		</ContainerMax>
	)
}

export default CtaWithBackgroundImage